<template>
    <div>
        <h1>
            <div class="d-flex align-items-center justify-content-center h-100">
                <span class="number">$</span>
                <span v-for="number in rollingNumbers" :key="number.i" :class="number.class" >{{number.value}}</span>
            </div>
        </h1>
        <h2 class="d-none">
            {{detail}}
        </h2>
        <button @click="toggle" class="pause" :class="{paused: timer}">{{ buttonText }}</button>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import Formatting from "@/util/formatting.js";
export default {
    data : function () {
        return {
            timer : false,
            buttonText : "Pause"
        }
    },
    destroyed:function(){
        clearInterval(this.timer);
        this.timer = false;
        this.buttonText = "Pause";
    },
    mounted() {
        this.timer = setInterval( () =>{
            this.getCounterInterval();
        //    this.getFactoidInterval();
        }, 50)
    },
    methods : {
        ...mapActions('tvd/',[
             'getCounterInterval',
          //  'getFactoidInterval'
        ]),
        toggle : function(){
            if(this.timer){
                clearInterval(this.timer)
                this.timer = false;
                this.buttonText = "Play";
            } else {
                this.play();
                this.buttonText = "Pause";
            }
        },
        play : function(){
            this.timer = setInterval( () =>{
                this.getCounterInterval();
            }, 50);
        }
    },
    computed : {
        ...mapGetters('tvd/',[
            'runRate',
            'count',
        ]),
        rollingNumbers : function(){
            return Formatting.htmlizeNumbers(Formatting.commaSeparateNumber(_.ceil(this.count)));
        },
        detail : function(){
            //if(this.count > 999){
            //    return Formatting.numberToText(this.count);
            //}
        }
    }
}
</script>